<div class="uk-card uk-card-default" style="margin: 0 1rem 1rem 0"*ngIf="statisfactionData">
  <div class="uk-card-header uk-padding-small" [ngClass]="[headerBackground]">
    <div class="uk-grid-small uk-flex-middle uk-grid">
      <div class="uk-width-expand uk-width-5-6">
        <h3 class="uk-card-title uk-margin-remove-bottom primary-color " [ngClass]="[headerColor]">
          Satisfaction stagiaire
        </h3>
      </div>
      <div class="info primary-color uk-width-1-6 k-text-right">
        <i
          class="k-icon k-i-info"
          uk-tooltip="Il s’agit du taux de satisfaction des stagiaires calculé à partir des réponses aux questionnaires d’évaluation de la formation.</br>
                   Notez que cet indicateur comportera des données uniquement si le filtre est activé pour les statuts « Terminé » et/ou « Archivé ».</br>
                   Notez également que le statut des sessions évoluant dans le temps, les données peuvent varier en fonction du moment de la consultation de l’indicateur.</br>
                   Masquez/affichez cet indicateur sur l’extranet du client à l’aide du switch situé en haut à droite de la tuile.
"
        ></i>
      </div>
    </div>
  </div>
  <div class="uk-card-body uk-padding-small">

      <p class="margin-left-12" *ngIf="statisfactionData.satisfaction[0].satisfaction > 0">
          <span class="stats-number-before "
          >{{ statisfactionData.satisfaction[0].satisfaction | number: '0.2' }}%</span
          >
      </p>
      <p class="margin-left-12" *ngIf="!statisfactionData.satisfaction[0].satisfaction">
        <span class="no-data">Donnée indisponible</span>
      </p>
      <div>
        <ags-kendo-progress-bar
          [height]="7"
          [style.width.%]="60"
          [type]="'value'"
          [value]="statisfactionData.satisfaction[0].satisfaction"
          [max]="100"
          [min]="0"
        ></ags-kendo-progress-bar>
      </div>
      <br />
    </div>
</div>
